import LoginForm from "@/components/login-form"
import { WithTranslation, withTranslation } from 'react-i18next';
import LanguageBox from "@/components/language-box";
import Welcome from "@/components/welcome";
import ResetPasswordForm from "@/components/reset-password-form";
import FitScale from "@/components/fit-scale";
import { Theme, THEME } from "@/components/login-theme";

function ResetPasswordPage({
    t,
    ...props
  }: WithTranslation) {
  // Welcome 改版后需要 theme/colors（沿用登录页取值逻辑）；本页无主题切换，固定默认 orange。
  const theme: Theme = 'orange';
  const colors = THEME[theme];
  // ≥lg 锁定视口高度、不滚动，表单用 FitScale 等比缩放适配（复刻登录页「无滚动栏」）；
  // <lg 维持原 min-h-svh 流式可滚动，移动端行为不变。
  return (
    <div className="w-full grid min-h-svh lg:h-svh lg:overflow-hidden lg:grid-cols-[1fr_2fr]">
      <Welcome theme={theme} colors={colors} variant="panel" />
      <div className="flex flex-col gap-4 p-6 md:p-10 min-h-svh lg:h-svh lg:overflow-hidden">
        <div className="flex gap-2 justify-end shrink-0">
          <LanguageBox></LanguageBox>
        </div>
        <FitScale className="flex-1">
          <div className="w-full max-w-xs mx-auto">
            <ResetPasswordForm/>
          </div>
        </FitScale>
      </div>
    </div>
  )
}

export default withTranslation()(ResetPasswordPage);